(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  var US_WEEKDAY_MAP = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var TIMER_KEY = '_aFlashSaleCountdownTimer';

  function getZonedDateParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    });
    var parts = formatter.formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    var hour = Number(values.hour);
    if (hour === 24) hour = 0;

    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      weekday: values.weekday,
      hour: hour,
      minute: Number(values.minute),
      second: Number(values.second)
    };
  }

  function getTimezoneOffsetMs(date, timeZone) {
    var parts = getZonedDateParts(date, timeZone);
    var asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return asUtc - date.getTime();
  }

  function zonedTimeToUtc(year, month, day, hour, minute, second, timeZone) {
    var utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);
    var date = new Date(utcGuess);
    return new Date(utcGuess - getTimezoneOffsetMs(date, timeZone));
  }

  function addCalendarDays(year, month, day, days) {
    var date = new Date(Date.UTC(year, month - 1, day + days));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate()
    };
  }

  function getWeeklyUsCycleEndDate(now, timeZone) {
    var parts = getZonedDateParts(now, timeZone);
    var dayOfWeek = US_WEEKDAY_MAP[parts.weekday];
    var daysUntil;

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      daysUntil = 6 - dayOfWeek;
    } else if (dayOfWeek === 6) {
      daysUntil = 2;
    } else {
      daysUntil = 1;
    }

    var targetDate = addCalendarDays(parts.year, parts.month, parts.day, daysUntil);
    return zonedTimeToUtc(targetDate.year, targetDate.month, targetDate.day, 0, 0, 0, timeZone);
  }

  function getFixedEndDate(root) {
    var endAt = root.dataset.countdownEnd;
    if (!endAt) return null;

    var endDate = new Date(endAt);
    return Number.isNaN(endDate.getTime()) ? null : endDate;
  }

  function resolveEndDate(root) {
    if (root.hasAttribute('data-countdown-weekly-us-cycle')) {
      var timeZone = root.dataset.countdownTimezone || 'America/Los_Angeles';
      return getWeeklyUsCycleEndDate(new Date(), timeZone);
    }

    return getFixedEndDate(root);
  }

  function getCountdownEls(root) {
    return {
      countdown: root.querySelector('.countdown__main'),
      countdownHeading: root.querySelector('.countdown__end-info'),
      daysEl: root.querySelector('.countdown_block_days'),
      hoursEl: root.querySelector('.countdown_block_hours'),
      minutesEl: root.querySelector('.countdown_block_minutes'),
      secondsEl: root.querySelector('.countdown_block_seconds')
    };
  }

  function setCountdownValues(els, values) {
    if (els.daysEl) els.daysEl.textContent = values.days;
    if (els.hoursEl) els.hoursEl.textContent = values.hours;
    if (els.minutesEl) els.minutesEl.textContent = values.minutes;
    if (els.secondsEl) els.secondsEl.textContent = values.seconds;
  }

  function handleCompleted(root, els) {
    var completed = root.dataset.completed || 'show_text';
    var section = root.closest('.a-flash-sale');

    if (completed === 'hide_section' && section) {
      clearInterval(root[TIMER_KEY]);
      root[TIMER_KEY] = null;
      section.style.display = 'none';
      return true;
    }

    if (completed === 'show_text') {
      if (els.countdown) els.countdown.style.display = 'none';
      if (els.countdownHeading) els.countdownHeading.style.display = 'flex';
      return true;
    }

    if (completed === 'show_hyphens') {
      setCountdownValues(els, { days: '--', hours: '--', minutes: '--', seconds: '--' });
      return true;
    }

    return false;
  }

  function initCountdown(root) {
    if (!root) return;

    if (root[TIMER_KEY]) {
      clearInterval(root[TIMER_KEY]);
      root[TIMER_KEY] = null;
    }

    var isWeeklyCycle = root.hasAttribute('data-countdown-weekly-us-cycle');
    var els = getCountdownEls(root);

    function tick() {
      var endDate = resolveEndDate(root);
      if (!endDate) return;

      var diff = endDate.getTime() - Date.now();

      if (diff <= 0) {
        if (isWeeklyCycle) {
          setCountdownValues(els, { days: '00', hours: '00', minutes: '00', seconds: '00' });
          return;
        }

        if (handleCompleted(root, els)) return;

        clearInterval(root[TIMER_KEY]);
        root[TIMER_KEY] = null;
        setCountdownValues(els, { days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      setCountdownValues(els, {
        days: pad(days),
        hours: pad(hours),
        minutes: pad(minutes),
        seconds: pad(seconds)
      });
    }

    tick();
    root[TIMER_KEY] = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    var timers = scope.querySelectorAll('[data-a-flash-sale-countdown]');
    timers.forEach(initCountdown);
  }

  function destroyIn(root) {
    if (!root) return;
    var timers = root.querySelectorAll('[data-a-flash-sale-countdown]');
    timers.forEach(function (timer) {
      if (timer[TIMER_KEY]) {
        clearInterval(timer[TIMER_KEY]);
        timer[TIMER_KEY] = null;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
